import type { RouteRecordRaw } from 'vue-router';

export const LOGIN = 'login';
export const FORGOT_PASSWORD_REQUEST = 'forgotpassword';
export const RESET_PASSWORD = 'resetpassword';
export const ONBOARDING = 'onboarding';
const routes: RouteRecordRaw[] = [
  {
    path: 'login',
    name: LOGIN,
    component: () => import('./pages/LoginPage.vue'),
  },
  {
    path: 'logout',
    component: () => import('./pages/LogoutPage.vue'),
  },
  {
    path: 'forgot-password',
    name: FORGOT_PASSWORD_REQUEST,
    component: () => import('./pages/PasswordRequestPage.vue'),
  },
  {
    path: 'reset-password',
    name: RESET_PASSWORD,
    component: () => import('./pages/ResetPasswordPage.vue'),
  },
  {
    path: 'setup/:accountNumber?',
    name: ONBOARDING,
    component: () => import('./pages/OnboardingPage.vue'),
  },
];
export default routes;
